// extracted by mini-css-extract-plugin
module.exports = {"testimonios":"testimonios-module--testimonios--SidIr","headerExplain":"testimonios-module--headerExplain--19C5t"};